import ejs from "ejs";
import { Buffer } from "buffer";
import { API_URL } from "./const";
import api from "./helpers/api";
import { ITemplateConfig, ITemplateConfigObj } from "./interfaces/IPageDesigner";

export function renderContent(rawEjs: string, data: any): string {
  try {
    return ejs.render(rawEjs, data);
  } catch (error) {
    throw error;
  }
}

export function executeJs(js: string): void {
  let jsObj = JSON.parse(Buffer.from(js, "base64").toString());
  setTimeout(eval, 100, jsObj)
}

export async function getTemplate(templateId: number, templateConfig: ITemplateConfigObj, queryParams: string) {
  try {
    let result = await api.post(`/get-template/${templateId}/${queryParams}`, JSON.stringify({ templateConfig: templateConfig }));
    return result.data;
  } catch (error) {
    console.error("error", error);
  }
}
